import type { SearchkitWrapperProps } from '@uncinc/react-searchkit/dist/components/Wrapper';

export const searchAttributes = [
  // Content.
  'page_title',
  'body',
  'body_summarized',
  'paragraphs_body',
  'equipment_types_searchable',
  'themes_searchable',
  'departments_searchable',
  'article_type_searchable',
  'project_research_leader_name',
  'locations_name',
  'labels_searchable',

  // Profile.
  'first_name_searchable',
  'last_name_searchable',
  'profile_departments_searchable',
  'profile_locations_name',

  // Taxonomies.
  'taxonomy_name',
  'taxonomy_description',

  // IMIS publication
  'imis_publication_title',
  'imis_publication_authors',
];

export const resultAttributes = [
  // General.
  'image_ratio_1_1_xxs',
  'image_ratio_1_1_xs',
  'image_ratio_1_1_sm',
  'image_ratio_1_1_md',

  'image_ratio_3_2_xxs',
  'image_ratio_3_2_xs',
  'image_ratio_3_2_sm',
  'image_ratio_3_2_md',

  'image_ratio_3_4_xxs',
  'image_ratio_3_4_xs',
  'image_ratio_3_4_sm',
  'image_ratio_3_4_md',

  'image_ratio_4_3_xxs',
  'image_ratio_4_3_xs',
  'image_ratio_4_3_sm',
  'image_ratio_4_3_md',

  'image_ratio_16_9_xxs',
  'image_ratio_16_9_xs',
  'image_ratio_16_9_sm',
  'image_ratio_16_9_md',

  'url',

  // Content.
  'nid',
  'entity_type',
  'page_title',
  'langcode',
  'created',
  'content_type',
  'body',
  'body_processed',
  'body_summarized',
  'image_alt',
  'langcode',
  'paragraphs_body_processed',

  // Taxonomies
  'labels_name',
  'themes_name',

  // Article - Vacancy
  'publish_date',

  // Article
  'article_type_name',

  // Equipment
  'equipment_types_name',

  // Project
  'project_duration_start_date',
  'project_duration_end_date',
  'project_research_leader_name',
  'project_project_team',

  // Vacancy
  'employment_types',
  'vacancy_function_name',
  'locations_name',
  'locations_tid',
  'link_url',
  'link_text',

  // Department
  'departments_name',

  // Profile
  'profile_type',
  'profile_id',
  'first_name',
  'last_name',
  'profile_address',
  'profile_image_alt',
  'function_category',
  'profile_functions_name',
  'profile_locations_name',
  'head_of_department',
  'profile_departments_abbreviation',
  'educational_title',
  'profile_image_ratio_1_1_xxs',
  'profile_image_ratio_1_1_xs',
  'profile_image_ratio_1_1_sm',
  'profile_image_ratio_1_1_md',

  // Taxonomy
  'tid',
  'vid',
  'taxonomy_name',
  'taxonomy_description',
  'taxonomy_image_ratio_1_1_xxs',
  'taxonomy_image_ratio_1_1_xs',
  'taxonomy_image_ratio_1_1_sm',
  'taxonomy_image_ratio_1_1_md',
  'taxonomy_image_ratio_1_1_lg',
  'taxonomy_teaser_image_ratio_1_1_xxs',
  'taxonomy_teaser_image_ratio_1_1_xs',
  'taxonomy_teaser_image_ratio_1_1_sm',
  'taxonomy_teaser_image_ratio_1_1_md',
  'taxonomy_teaser_image_ratio_1_1_lg',
  'taxonomy_teaser_image_ratio_3_1_xxs',
  'taxonomy_teaser_image_ratio_3_1_xs',
  'taxonomy_teaser_image_ratio_3_1_sm',
  'taxonomy_teaser_image_ratio_3_1_md',
  'taxonomy_teaser_image_ratio_3_1_lg',
  'taxonomy_teaser_image_ratio_16_9_xxs',
  'taxonomy_teaser_image_ratio_16_9_xs',
  'taxonomy_teaser_image_ratio_16_9_sm',
  'taxonomy_teaser_image_ratio_16_9_md',
  'taxonomy_teaser_image_ratio_16_9_lg',
  'taxonomy_teaser_image_ratio_2_3_xxs',
  'taxonomy_teaser_image_ratio_2_3_xs',
  'taxonomy_teaser_image_ratio_2_3_sm',
  'taxonomy_teaser_image_ratio_2_3_md',
  'taxonomy_teaser_image_ratio_2_3_lg',
  'taxonomy_teaser_image_ratio_3_4_xxs',
  'taxonomy_teaser_image_ratio_3_4_xs',
  'taxonomy_teaser_image_ratio_3_4_sm',
  'taxonomy_teaser_image_ratio_3_4_md',
  'taxonomy_teaser_image_ratio_3_4_lg',
  'taxonomy_teaser_image_ratio_4_3_xxs',
  'taxonomy_teaser_image_ratio_4_3_xs',
  'taxonomy_teaser_image_ratio_4_3_sm',
  'taxonomy_teaser_image_ratio_4_3_md',
  'taxonomy_teaser_image_ratio_4_3_lg',

  // IMIS publications
  'imis_publication_bref_id',
  'imis_publication_authors',
  'imis_publication_title',
  'imis_publication_year',
  'imis_publication_journal',
  'imis_publication_url',
  'imis_publication_departments',

  // ORCID publications
  'orcid_publication_id',
  'orcid_publication_title',
  'orcid_publication_year',
  'orcid_publication_external_id',
  'orcid_publication_external_id_url',
  'orcid_publication_citation',
  'orcid_publication_citation_type',
];

export const facetAttributes: Exclude<SearchkitWrapperProps['searchSettings']['facet_attributes'], undefined> = [
  {
    attribute: 'article_type_name',
    field: 'article_type_name',
    type: 'string',
  },
  {
    attribute: 'themes_name',
    field: 'themes_name',
    type: 'string',
  },
  {
    attribute: 'departments_name',
    field: 'departments_name',
    type: 'string',
  },
  {
    attribute: 'profile_departments_name',
    field: 'profile_departments_name',
    type: 'string',
  },
  {
    attribute: 'locations_name',
    field: 'locations_name',
    type: 'string',
  },
  {
    attribute: 'profile_functions_name',
    field: 'profile_functions_name',
    type: 'string',
  },
  {
    attribute: 'function_category',
    field: 'function_category',
    type: 'numeric',
  },
  {
    attribute: 'profile_locations_name',
    field: 'profile_locations_name',
    type: 'string',
  },
  {
    attribute: 'equipment_types_name',
    field: 'equipment_types_name',
    type: 'string',
  },
  {
    attribute: 'imis_publication_departments_name',
    field: 'imis_publication_departments_name',
    type: 'string',
  },
  {
    attribute: 'imis_publication_year',
    field: 'imis_publication_year',
    type: 'numeric',
  },
];

export const sorting: Exclude<SearchkitWrapperProps['searchSettings']['sorting'], undefined> = {
  default: [
    // Default sorting by score.
    {
      field: '_score',
      order: 'desc',
    },
    // Articles and vacancies.
    {
      field: 'publish_date',
      order: 'desc',
    },
    // Projects.
    {
      field: 'project_duration_start_date',
      order: 'desc',
    },
    // Other nodes.
    {
      field: 'created',
      order: 'desc',
    },
    // Profiles.
    {
      field: 'head_of_department',
      order: 'desc',
    },
    {
      field: 'last_name',
      order: 'asc',
    },
    // Taxonomy terms.
    {
      field: 'taxonomy_weight',
      order: 'asc',
    },
    // IMIS publication.
    {
      field: 'imis_publication_year',
      order: 'desc',
    },
    // ORCID publication.
    {
      field: 'orcid_publication_year',
      order: 'desc',
    },
  ],
};
